module.exports = __webpack_public_path__ + "a4437d7d9c156211bf568c2747cd7cf3.png";